import { useQuery } from "@tanstack/react-query";
import { CheckCircle2, ListTodo, Target } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { ErrorScreen, LoadingScreen } from "../components/ScreenState";
import { api } from "../lib/api";

export function ReportPage() {
  const data = useQuery({ queryKey: ["bootstrap"], queryFn: api.bootstrap });
  if (data.isPending) return <LoadingScreen />;
  if (data.isError) return <ErrorScreen message={data.error.message} onRetry={() => void data.refetch()} />;
  const report = data.data.report;
  return (
    <section className="screen">
      <PageHeader title="报告" />
      <div className="report-hero">
        <div className="rate-ring" style={{ "--rate": `${report.rate * 3.6}deg` } as React.CSSProperties}>
          <span><strong>{report.rate}%</strong><small>总体完成率</small></span>
        </div>
        <p>{report.totalItems > 0 ? "每完成一次，计划进度都会实时更新。" : "完成第一项今日任务后，这里会显示学习进度。"}</p>
      </div>
      <div className="metric-list">
        <div><CheckCircle2 /><span>已完成计划项</span><strong>{report.doneItems}</strong></div>
        <div><ListTodo /><span>全部计划项</span><strong>{report.totalItems}</strong></div>
        <div><Target /><span>已完成总量</span><strong>{report.completed}/{report.total}</strong></div>
      </div>
      <div className="insight-block">
        <h2>本周建议</h2>
        <p>{report.rate >= 80 ? "当前节奏很好，继续按计划完成即可。" : "优先完成今天的任务；若压力过大，可调整作业截止日期后重新生成计划。"}</p>
      </div>
    </section>
  );
}
